import { useReactFlow } from 'reactflow';

export const submitPipeline = async (nodes, edges) => {
  try {
    const response = await fetch('http://localhost:8000/pipelines/parse', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nodes, edges }),
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const result = await response.json();
    const { num_nodes, num_edges, is_dag } = result;

    // Remove any existing overlay first
    const existingOverlay = document.getElementById('pipeline-result-overlay');
    if (existingOverlay) existingOverlay.remove();

    const overlay = document.createElement('div');
    overlay.id = 'pipeline-result-overlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      animation: fadeIn 0.15s ease;
    `;

    const dagColor  = is_dag ? '#16A34A' : '#DC2626';
    const dagBg     = is_dag ? '#F0FDF4' : '#FEF2F2';
    const dagBorder = is_dag ? '#86EFAC' : '#FECACA';
    const dagIcon   = is_dag ? '✓' : '✗';
    const dagLabel  = is_dag ? 'Valid DAG' : 'Not a DAG (contains cycles)';

    overlay.innerHTML = `
      <style>
        @keyframes fadeIn  { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(16px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        #pipeline-result-card { animation: slideUp 0.2s ease; }
        #pipeline-result-card .stat-card {
          display: flex; flex-direction: column; align-items: center;
          background: #F9FAFB; border: 0.5px solid #E5E7EB;
          border-radius: 10px; padding: 14px 20px; min-width: 90px;
        }
        #pipeline-result-card .stat-value {
          font-size: 28px; font-weight: 700; color: #111827;
          line-height: 1; margin-bottom: 4px;
        }
        #pipeline-result-card .stat-label {
          font-size: 11px; font-weight: 600; text-transform: uppercase;
          letter-spacing: 0.07em; color: #6B7280;
        }
        #pipeline-result-close:hover { background: #F3F4F6; }
      </style>

      <div id="pipeline-result-card" style="
        background: #FFFFFF; border-radius: 16px; border: 1px solid #E5E7EB;
        box-shadow: 0 20px 60px rgba(0,0,0,0.18);
        padding: 28px 32px; width: 340px; position: relative;
      ">
        <button id="pipeline-result-close" style="
          position: absolute; top: 14px; right: 14px;
          width: 28px; height: 28px; border: none; background: transparent;
          border-radius: 6px; font-size: 16px; color: #9CA3AF;
          cursor: pointer; display: flex; align-items: center; justify-content: center;
        ">✕</button>

        <div style="margin-bottom: 20px;">
          <div style="font-size: 13px; font-weight: 600; color: #6B7280; text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 4px;">
            Pipeline Analysis
          </div>
          <div style="font-size: 20px; font-weight: 700; color: #111827;">Results</div>
        </div>

        <div style="display: flex; gap: 10px; margin-bottom: 16px;">
          <div class="stat-card">
            <div class="stat-value">${num_nodes}</div>
            <div class="stat-label">Nodes</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">${num_edges}</div>
            <div class="stat-label">Edges</div>
          </div>
        </div>

        <div style="
          display: flex; align-items: center; gap: 10px;
          background: ${dagBg}; border: 1px solid ${dagBorder};
          border-radius: 10px; padding: 12px 16px;
        ">
          <div style="
            width: 28px; height: 28px; border-radius: 50%;
            background: ${dagColor}; color: white;
            display: flex; align-items: center; justify-content: center;
            font-size: 14px; font-weight: 700; flex-shrink: 0;
          ">${dagIcon}</div>
          <div>
            <div style="font-size: 13px; font-weight: 600; color: ${dagColor};">${dagLabel}</div>
            <div style="font-size: 11px; color: #6B7280; margin-top: 2px;">
              ${is_dag
                ? 'Pipeline has no cycles — safe to execute.'
                : 'Pipeline contains a cycle — check your connections.'}
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });
    document.getElementById('pipeline-result-close').addEventListener('click', () => {
      overlay.remove();
    });

  } catch (err) {
    console.error('Pipeline submission failed:', err);

    const toast = document.createElement('div');
    toast.style.cssText = `
      position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
      background: #1F2937; color: #F9FAFB; padding: 10px 20px;
      border-radius: 8px; font-size: 13px; font-family: inherit;
      z-index: 9999; box-shadow: 0 4px 16px rgba(0,0,0,0.3);
    `;
    toast.textContent = `Submission failed: ${err.message}`;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }
};

// Submit Button Component 
export const SubmitButton = () => {
  const { getNodes, getEdges } = useReactFlow();

  const handleSubmit = () => {
    submitPipeline(getNodes(), getEdges());
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <button
        onClick={handleSubmit}
        style={{
          padding: '8px 24px',
          background: '#111827',
          color: '#FFFFFF',
          border: 'none',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
          letterSpacing: '0.02em',
        }}
      >
        Submit Pipeline
      </button>
    </div>
  );
};